import React from 'react';

interface FormSelectOption {
  value: string;
  label: string;
}

interface FormSelectProps {
  id: string;
  label: string;
  options: FormSelectOption[];
  error?: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
}

export function FormSelect({
  id,
  label,
  options,
  error,
  value,
  onChange,
  onBlur,
}: FormSelectProps) {
  return (
    <div>
      <label htmlFor={id} className="mb-2 block text-[14px] font-normal leading-[170%] text-[#3B3B3B]">
        {label}
      </label>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        style={{
          borderWidth: '1.5px',
          borderStyle: 'solid',
          borderColor: error ? '#EF4444' : '#E5E7EB',
          padding: '12px 16px',
        }}
        className={`w-full rounded-lg bg-white text-[16px] leading-[170%] text-[#3B3B3B] focus:outline-none focus:ring-2 focus:ring-[#7CF1C7] focus:border-transparent`}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
}
